import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import {
  setClientTokenRefreshHandler,
  setUnauthorizedHandler,
} from '@/api/unauthorized'
import { isDevAuthBypass } from '@/lib/devAuth'
import { router } from '@/router'
import { useAuthStore } from '@/store/useAuthStore'
import { useRuntimeStore } from '@/store/useRuntimeStore'

export function App() {
  useEffect(() => {
    useRuntimeStore.getState().init()
    void useAuthStore.getState().init()

    // 客户端 401：由 HTTP 层单飞调用并重试原请求一次（对齐 org-console）
    setClientTokenRefreshHandler(() => useAuthStore.getState().refreshFromHost())

    setUnauthorizedHandler(() => {
      if (isDevAuthBypass()) return
      useAuthStore.getState().logout()
      // 客户端：只清本地态，不跳 /login
      if (useRuntimeStore.getState().isClient) return
      const loc = router.state.location
      if (loc.pathname === '/login') return
      const from = `${loc.pathname}${loc.search}`
      void router.navigate(`/login?from=${encodeURIComponent(from)}`, {
        replace: true,
      })
    })

    return () => {
      setUnauthorizedHandler(null)
      setClientTokenRefreshHandler(async () => false)
    }
  }, [])

  return <RouterProvider router={router} />
}
